import { render, staticRenderFns } from "./ushouldknow.vue?vue&type=template&id=09bf213c&scoped=true&"
import script from "./ushouldknow.vue?vue&type=script&lang=js&"
export * from "./ushouldknow.vue?vue&type=script&lang=js&"
import style0 from "./ushouldknow.vue?vue&type=style&index=0&id=09bf213c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bf213c",
  null
  
)

export default component.exports